<div>
    <h2 mat-dialog-title class="!text-2xl !font-normal !text-primary-700 !mb-2">
        Add Line Item
    </h2>
    <hr />
    <mat-dialog-content class="ps-6 pt-2 mat-typography">
        <form [formGroup]="form" class="flex flex-col">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Service</mat-label>
                <input
                    title="Service"
                    matInput
                    [formControl]="form.controls.productName"
                    [matAutocomplete]="addAutocomplete"
                    [appRegexInput]="regExPattern.AllowAllCharacters"
                />
                <mat-autocomplete
                    autoActiveFirstOption
                    #addAutocomplete="matAutocomplete"
                    [hideSingleSelectionIndicator]="true"
                >
                    @for (
                        productOption of filteredProductDropdownOptions;
                        track productOption.value
                    ) {
                        <mat-option [value]="productOption.label">
                            {{ productOption.label }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Description</mat-label>
                <textarea
                    title="Description"
                    matInput
                    [formControl]="form.controls.description"
                    [maxLength]="orderLineItemConstants.DESCRIPTION_MAX_LENGTH"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiAndPermittedControlCharactersExceptAngleBracketsAndPipes
                    "
                ></textarea>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-3/12">
                <mat-label>Quantity</mat-label>
                <input
                    matInput
                    title="Quantity"
                    [formControl]="form.controls.quantity"
                    [imask]="orderLineItemMaskConfig.quantity"
                />
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-3/12">
                <mat-label>Rate</mat-label>
                <input
                    matInput
                    title="Rate"
                    [formControl]="form.controls.price"
                    [imask]="orderLineItemMaskConfig.rate"
                />
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!pb-5 !pr-5">
        <button
            type="button"
            mat-stroked-button
            color="primary"
            class="!border-primary-700"
            (click)="onCancel()"
        >
            Cancel
        </button>
        <button
            mat-raised-button
            type="button"
            name="Save"
            cdkFocusInitial
            color="primary"
            [disabled]="form.invalid"
            (click)="onSave()"
        >
            Save
        </button>
    </mat-dialog-actions>
</div>
